import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { EventDialogView } from './EventDialogView';
import * as selectors from '../../store/selectors';
import {
  updateEvent,
  deleteEvent,
  submitEventReport,
} from '../../store/events.actions';
import { showNotification } from '../../store/notification.actions';
import { useEventCallback } from '../../helpers/hooks';

// TODO Convert to typescript
export const EventDialog = ({ onClose }) => {
  const { eventId } = useParams();
  const event = useSelector(state => selectors.getEventById(state, eventId));
  const events = useSelector(selectors.getEvents);
  const airports = useSelector(selectors.getAirports);
  const rampServices = useSelector(selectors.getSortedRampServices);
  const dispatch = useDispatch();

  const handleSubmit = useEventCallback(
    async (id, values) => {
      await dispatch(updateEvent(id, values));
    },
    [dispatch]
  );

  const handleDelete = useEventCallback(
    async id => {
      await dispatch(deleteEvent(id));
      onClose();
    },
    [dispatch, onClose]
  );

  const handleEventReportSubmit = useEventCallback(
    async id => {
      await dispatch(submitEventReport(id));
    },
    [dispatch]
  );

  const handleNotificationShow = useEventCallback(
    notification => {
      dispatch(showNotification(notification));
    },
    [dispatch]
  );

  if (!event) return null;

  return (
    <EventDialogView
      isOpen
      event={event}
      events={events}
      airports={airports}
      rampServices={rampServices}
      onClose={onClose}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
      onEventReportSubmit={handleEventReportSubmit}
      onNotificationShow={handleNotificationShow}
    />
  );
};
